import React from 'react';
import styles, { mainCls } from './styles';
import Grid from '../../Grid';
import GridItem from '../../GridItem';
import Spinner from '../../Spinner';
import createStyle from 'shared-utils/src/createStyle';

const useStyles = createStyle(styles);

const FakeQRCode = ({ size = 100, }) => {
  const cls = useStyles();
  return (
    <Grid align="center" justify="space-between"
      style={{ height: size, width: size }}
      className={`${cls[mainCls]}__loader-cnt`} >
      <GridItem className={`${cls[mainCls]}__spinner_cnt is-rel`}>
        <div className={`${cls[mainCls]}__spinner_img`}>
          <Spinner
            valignCenter size="lx" 
            weight="l" 
            color="f0" 
            noOpacity 
            className={`${cls[mainCls]}__spinner`}
          />
        </div>
      </GridItem>
    </Grid>
  );
};

export default FakeQRCode;
